/* eslint-disable prefer-const */
/* eslint-disable camelcase */
import React, { useState } from "react";
import Box from "@mui/material/Box";
import Avatar from "@mui/material/Avatar";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import Menu from "@mui/material/Menu";
import { useAppDispatch, useAppSelector } from "store"; // keep your store hooks
import { logoutUser } from "store/slice/authSlice";
import { setActiveChatDetails, setActiveChatId, setOutletLoading, setPromptInput, setShowInsightsOnUi, setUser } from "store/slice/userSlice";
import { useMsal } from "@azure/msal-react";
import Swal from "sweetalert2";
import { MenuAccountInfo, MenuDashboard, MenuDeleteAllChats, MenuDomainControl, MenuLogout, MenuManageUsers } from "assets/images/icons";
import { Modal } from "@mui/material";
// import SettingModal from "../SettingModal";
// import RegisterModal from "../RegisterModal";
import { deleteUserChat, getUserConversationSummaryResponse } from "constants/common";
import { setIsClarificationCurrentlyActive, setDisplayRecommendedOptions, setConversationHistory, toggleInsightsAgentsError, setConversationSummary } from "store/slice/conversationSlice";
import { useNavigate } from "react-router-dom";
import AccountInfoDrawer from "./accountInfoDrawer";


type RowProps = {
  icon: React.ReactNode;
  label: string;
  hint?: React.ReactNode;
  danger?: boolean;
  onClick?: () => void;
};

function Row({ icon, label, hint, danger = false, onClick }: RowProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={`flex items-center justify-between gap-3 w-full text-sm px-3 py-2 transition text-[#363636] dark:text-gray-200 hover:bg-[#FCE3C7] dark:hover:bg-gray-700 
        ${danger
          ? "mb-[-8px] text-red-600"
          : ""
        }`}
    >
      <div className="flex items-center gap-3">
        <div className="pl-1 flex items-center justify-center text-gray-600 dark:text-gray-300">
          {icon}
        </div>
        <span className="text-[12px]">{label}</span>
      </div>
      <div className="flex items-center gap-2">
        {hint}
      </div>
    </button>
  );
}

export default function AccountMenu({ onApply }: { onApply?: () => void }) {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [openSettingsModal, setOpenSettingsModal] = useState(false);
  const [openRegisterModal, setOpenRegisterModal] = useState(false);
  const [accountInfoOpen, setAccountInfoOpen] = useState(false);
  const [openLogoutDialog, setOpenLogoutDialog] = useState(false); // State to handle logout confirmation dialog
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false); // State to handle delete confirmation dialog
  const { user_id,selectedDomain,name,userType } = useAppSelector((s) => s.user);
  const dispatch = useAppDispatch();
  const { instance } = useMsal();
  const navigate = useNavigate();
  const open = Boolean(anchorEl);
  const handleClick = (e: React.MouseEvent<HTMLElement>) => setAnchorEl(e.currentTarget);
  const handleClose = () => setAnchorEl(null);

  const handleSettingsOpen = () => {
    setOpenSettingsModal(true);
    handleClose();
  };
  const handleSettingsClose = () => setOpenSettingsModal(false);

  const handleRegisterOpen = () => {
    setOpenRegisterModal(true);
    handleClose();
  };
  const handleRegisterClose = () => setOpenRegisterModal(false);

  const handleDashboardOpen = () => {
    window.open("https://insightspro.tigeranalyticstest.in/grafana", "_blank");
    handleClose();
  };

  const handleDeleteClose = () => {
    setOpenDeleteDialog(false);
  };

  const handleDeleteAllChats = () => {
    setOpenDeleteDialog(true);
  };

  const handleConfirmDelete = async () => {
    handleClose();
    setOpenDeleteDialog(false);
    dispatch(setOutletLoading(true));
    try {
      const payload: any = {
        username: user_id,
        chat_id: '',
        domain_name: selectedDomain,
        all_chats: true
      }
      const response=await deleteUserChat(payload);
    if (response.data.status) {

      const conversationSummaryPayload: any = {
        username: user_id,
        domain_name: selectedDomain
      }
      const summaryResponse = await getUserConversationSummaryResponse(conversationSummaryPayload);
      if (summaryResponse?.data) {
        const updatedSummary = summaryResponse.data;
        dispatch(setConversationSummary(updatedSummary));
      } else {
        dispatch(setConversationSummary([]))
      }
      console.log('in delte all chats');
      dispatch(setShowInsightsOnUi(false))
      dispatch(setActiveChatId('new'))
      dispatch(setIsClarificationCurrentlyActive(false))
      dispatch(setDisplayRecommendedOptions(false));
      navigate("/threads/new");
      dispatch(setConversationHistory([]));
      dispatch(toggleInsightsAgentsError(false));
      dispatch(setActiveChatDetails({}));
      dispatch(setPromptInput(""));
      dispatch(setOutletLoading(false));
    }
    } catch (error) {
      // console.log('Error deleting chat:', error);
    }
  };

  const handleLogoutClose = () => {
    setOpenLogoutDialog(false);
  }
  const handleLogout = () => {
    setOpenLogoutDialog(true);
  };
  const handleConfirmLogout = () => {
    setOpenLogoutDialog(false);
    const ssoLoginCheck = localStorage.getItem("sso");

    // dispatch logout locally first
    dispatch(logoutUser());
    dispatch(setUser(false));

    // if SSO, confirm and call MS logout popup
    // if (ssoLoginCheck) {
    //   Swal.fire({
    //     title: "Logout from Microsoft?",
    //     html: `<p style="font-size:14px;color:#555;margin-top:4px">You will be logged out of Microsoft SSO.</p>`,
    //     showCancelButton: true,
    //     confirmButtonText: "Yes",
    //     cancelButtonText: "No",
    //     buttonsStyling: false,
    //     customClass: {
    //       popup: "rounded-xl px-4 py-6",
    //       title: "text-lg font-semibold",
    //       htmlContainer: "text-sm text-gray-700",
    //       confirmButton: "bg-orange-400 hover:bg-orange-500 text-white px-4 py-2 rounded-md font-medium",
    //       cancelButton: "bg-gray-200 hover:bg-gray-300 text-gray-800 px-4 py-2 rounded-md font-medium ml-2",
    //     },
    //   }).then((result) => {
    //     if (result.isConfirmed) {
    //       // safe call — use your logoutRequest if defined
    //       try {
    //         // @ts-ignore - instance type may differ — use your logout helper
    //         instance.logoutPopup?.();
    //       } catch {
    //         // fallback full redirect logout
    //         instance.logout?.();
    //       }
    //     }
    //   });
    // } else {
    //   // non-SSO: just do client-side logout, or call API if needed
    //   // e.g. navigate to login
    // }
  };

  // const displayName = `User ${user_id?.slice?.(0, 1) ?? ""}`;
  const displayName = name === null?'InsightsPro User':name
  const displayRole = userType? userType.charAt(0).toUpperCase() + userType.slice(1) : 'User'

  return (
    <>
      <Box sx={{ display: "flex", alignItems: "center", textAlign: "center" }}>
        <Tooltip title="Account settings">
          <IconButton
            onClick={handleClick}
            size="small"
            sx={{ padding: 0 }}
            aria-controls={open ? "account-menu" : undefined}
            aria-haspopup="true"
            aria-expanded={open ? "true" : undefined}
          >
            <Avatar className='uppercase fontInsights' sx={{ width: 23, height: 23, bgcolor: "#F7901D", fontSize: 14 }}>
              {user_id?.slice?.(0, 1) ?? "U"}
            </Avatar>
          </IconButton>
        </Tooltip>
      </Box>

      <Menu
        anchorEl={anchorEl} className="accountMenu"
        id="account-menu"
        open={open}
        onClose={handleClose}        
        onClick={(e) => e.stopPropagation()} // prevent propagation if needed
        PaperProps={{
          elevation: 6,
          sx: {
            borderRadius: 2,
            overflow: "visible",
            mt: 2.1,
            ml: 2,
            minWidth: '200px',
            maxWidth: '200px',
            bgcolor: "background.paper",
            "&::before": {
              content: '""',
              display: "block",
              position: "absolute",
              top: 0,
              right: 15,
              width: 24,
              height: 24,
              bgcolor: "background.paper",
              transform: "translateY(-50%) rotate(45deg)",
              zIndex: 30,
            },

            boxShadow: "-4px -4px 20px 0px rgba(0,0,0,0.12)",
          },
        }}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
      >
        {/* Entire content structured to match screenshot */}
        <div className="rounded-lg w-full bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100">
          {/* Header */}
          <div className="flex items-center gap-3 px-4 py-2">
            <Avatar className='uppercase' sx={{ width: 30, height: 30, bgcolor: "#F7901D", fontSize: 16 }}>
              {user_id?.slice?.(0, 1) ?? "U"}
            </Avatar>
            <div className="flex-1">
              <div className="text-[12px] font-semibold text-[#F7901D]">{displayName}</div>
              <div className="text-[12px] text-gray-500 dark:text-gray-400">{displayRole === 'Sso'?displayRole?.toUpperCase():displayRole}</div>
            </div>
          </div>

          {/* Admin Panel */}
          {userType === 'admin' &&
            <div className="py-3">
            <div className="text-[10px] font-semibold text-[#707070] uppercase pl-4">Admin Panel</div>
            <div className=" ml-[-0.7px]">
              <Row icon={<MenuDashboard />} label="Analytical Dashboard" onClick={handleDashboardOpen} />
              <div className="border-b-[0.5px] mx-[1.05rem] border-[#CFCFCF] dark:border-gray-700" />
              <Row icon={<MenuManageUsers />} label="Manage Users" onClick={handleRegisterOpen} />
              <div className="border-b-[0.5px] mx-[1.05rem]  border-[#CFCFCF] dark:border-gray-700" />
              <Row icon={<MenuDomainControl />} label="Domain Control" onClick={handleSettingsOpen} />
              <div className="border-b-[0.5px] mx-[1.05rem]  border-[#CFCFCF] dark:border-gray-700" />
            </div>
          </div>}

          {/* Account Panel */}
          <div className="pt-3 dark:border-gray-700">
            <div className="text-[10px] font-semibold text-[#707070] uppercase  pl-4">Account Panel</div>
            <div className="ml-[-0.7px]">
              <Row
                icon={<MenuAccountInfo />}
                label="Account Info"
                onClick={() => {setAccountInfoOpen(true); handleClose();}}
              />
              <div className="border-b-[0.5px] mx-[1.05rem]  border-[#CFCFCF] dark:border-gray-700" />
              <Row icon={<MenuDeleteAllChats />} label="Delete all chats" onClick={handleDeleteAllChats} />
              <div className="border-b-[0.5px] mx-[1.05rem]  border-[#CFCFCF] dark:border-gray-700" />
              <Row icon={<MenuLogout />} label="Logout" danger onClick={handleLogout} />
            </div>
          </div>
        </div>
      </Menu>
      <AccountInfoDrawer open={accountInfoOpen} onClose={() => setAccountInfoOpen(false)} />
      {/*
        <MenuItem onClick={handleDownloadMetric}>
          <ListItemIcon>
            <DownloadIcon className="dark:text-[#ffffff]" fontSize="small" />
          </ListItemIcon>
          Metric Usage
        </MenuItem>
        <MenuItem onClick={handleModalOpen}>
          <ListItemIcon>
            <Settings className="dark:text-[#ffffff]" fontSize="small" />
          </ListItemIcon>
          Settings
        </MenuItem>
        {localStorage.getItem('user_type') === 'admin' &&
          <><MenuItem onClick={handleRegisterModalOpen}>
            <ListItemIcon>
              <HowToRegIcon className="dark:text-[#ffffff]" fontSize="small" />
            </ListItemIcon>
            Register
          </MenuItem>
    
        }

      {/* Modals */}      
      <Modal open={openDeleteDialog}>
        <div
          className="dark:bg-[#212121] bg-white absolute rounded-[10px] top-1/2 left-1/2 transform -translate-x-2/4 -translate-y-2/4 p-5 w-[376px] h-[158px] outline-none"
          data-testid="delete-chat-modal"
        >
          <div className="flex font-poppins dark:text-[#ffffff] font-semibold text-[14px] text-black mb-[25px]">
            Delete All Chat
          </div>
          <div className="fontInsights text-[12px] text-black">
            <p className="dark:text-[#ffffff]">
              Do you really want to clear all conversations?
            </p>
          </div>
          <div className="flex justify-end gap-5 mt-[30px] font-medium">
            <button
              type="button"
              className=" text-[12px]  text-[#8D8D8D] h-[27px] w-[69px]"
              onClick={handleDeleteClose}
            >
              Cancel
            </button>
            <button
              type="button"
              className="rounded-3xl text-[12px]  dark:bg-[#cf8600] bg-[#F7901D] text-[white] h-[28px] w-[68px]"
              onClick={handleConfirmDelete}
            >
              Delete
            </button>
          </div>
        </div>
      </Modal>

      <Modal open={openLogoutDialog}>
        <div
          className="dark:bg-[#212121] bg-white absolute rounded-[10px] top-1/2 left-1/2 transform -translate-x-2/4 -translate-y-2/4 p-5 w-[410px] h-[159px] outline-none"
          data-testid="delete-chat-modal"
        >
          <div className="flex font-poppins dark:text-[#ffffff] font-semibold text-[14px] text-black mb-[25px]">
            Logout
          </div>
          <div className="fontInsights text-[12px] text-black">
            <p className="dark:text-[#ffffff]">
              Do you wish to log out of Insights Pro?
            </p>
          </div>
          <div className="flex justify-end gap-5 mt-[30px] font-medium">
            <button
              type="button"
              className=" text-[12px]  text-[#8D8D8D] h-[28px] w-[47px]"
              onClick={handleLogoutClose}
            >
              No
            </button>
            <button
              type="button"
              className="rounded-3xl text-[12px]  dark:bg-[#cf8600] bg-[#F7901D] text-[white] h-[28px] w-[60px]"
              onClick={handleConfirmLogout}
            >
              Yes
            </button>
          </div>
        </div>
      </Modal>
    </>
  );
}